export const PRODUCT_NAME = 'SandraPay';
export const BRANDFETCH_CLIENT_ID = '1idrraIqfCWFg0DRD0B';
